import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { PAYWALL_MODE } from '@/base/const/paywall.const'

export default {
  watch: {
    paywallMode: function (value, oldValue) {
      if (value !== oldValue) {
        this.reloadPaywall()
      }
    },
    lang: function (value, oldValue) {
      if (value !== oldValue) {
        if (this.$meta) {
          this.$meta().refresh()
        }
        this.reloadPaywall()
      }
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.payment.loading,
      paywallMode: state => state.payment.paywallMode,
      paywallView: state => state.payment.paywallView,
      chosenPayway: state => state.payment.paymentData.chosenPayway,
      activePaywayId: state => state.payment.form.paywayID,
      reloadActivePaywayId: state => state.payment.reloadActivePayway,
      lang: state => state.lang.current
    }),
    ...mapGetters({
      paywayList: 'getPaywayList'
    })
  },
  methods: {
    ...mapMutations([
      'SET_PAYMENT_PAYWALL_VIEW',
      'SET_PAYMENT_LOADING',
      'SET_PAYMENT_RELOAD_ACTIVE_PAYWAY'
    ]),
    ...mapActions([
      'setPaymentActivePayway'
    ]),
    reloadPaywall () {
      if (this.isLoading) {
        return
      }
      const activePaywayId = this.activePaywayId
      if (activePaywayId) {
        this.SET_PAYMENT_RELOAD_ACTIVE_PAYWAY(activePaywayId)
      }
      const paywallViewState = this.paywallView
      this.SET_PAYMENT_LOADING(true)
      this.SET_PAYMENT_PAYWALL_VIEW(false)
      this.setPaymentActivePayway(null)

      setTimeout(() => {
        this.SET_PAYMENT_LOADING(false)
        this.SET_PAYMENT_PAYWALL_VIEW(paywallViewState)
        if (this.paywallMode === PAYWALL_MODE.regulationsApproval && this.reloadActivePaywayId && this.chosenPayway && this.chosenPayway.id === this.reloadActivePaywayId) {
          this.setPaymentActivePayway(this.chosenPayway)
        }
      }, 1000)
    }
  }
}
